import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-marketing-blog-breadcrumb',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nav class="cg-blog-breadcrumb" aria-label="Breadcrumb">
      <ol>
        <li><a routerLink="/">Home</a></li>
        <li><a routerLink="/blogs">Blogs</a></li>
        @if (categoryName && categorySlug) {
          <li><a [routerLink]="['/blogs/category', categorySlug]">{{ categoryName }}</a></li>
        }
        <li aria-current="page">{{ currentTitle }}</li>
      </ol>
    </nav>
  `,
})
export class MarketingBlogBreadcrumbComponent {
  @Input() currentTitle = '';
  @Input() categoryName?: string;
  @Input() categorySlug?: string;
}
